module.exports = __webpack_public_path__ + "static/media/garment-placeholder.27b5c3b6.svg";